import { token } from '@atlaskit/tokens';

export const PRIMARY_COLORS: {
	BLUE: 'var(--ds-background-accent-blue-subtle)';
	GREEN: 'var(--ds-background-accent-green-subtle)';
	YELLOW: 'var(--ds-background-accent-yellow-subtle)';
	RED: 'var(--ds-background-accent-red-subtle)';
	PURPLE: 'var(--ds-background-accent-purple-subtle)';
	VERIFIED: 'var(--ds-icon-accent-blue)';
} = {
	BLUE: token('color.background.accent.blue.subtle'),
	GREEN: token('color.background.accent.green.subtle'),
	YELLOW: token('color.background.accent.yellow.subtle'),
	RED: token('color.background.accent.red.subtle'),
	PURPLE: token('color.background.accent.purple.subtle'),
	VERIFIED: token('color.icon.accent.blue'),
};

export const SECONDARY_COLORS: {
	BLUE: 'var(--ds-background-accent-blue-subtlest)';
	GREEN: 'var(--ds-background-accent-green-subtlest)';
	YELLOW: 'var(--ds-background-accent-yellow-subtlest)';
	RED: 'var(--ds-background-accent-red-subtlest)';
	PURPLE: 'var(--ds-background-accent-purple-subtlest)';
} = {
	BLUE: token('color.background.accent.blue.subtlest'),
	GREEN: token('color.background.accent.green.subtlest'),
	YELLOW: token('color.background.accent.yellow.subtlest'),
	RED: token('color.background.accent.red.subtlest'),
	PURPLE: token('color.background.accent.purple.subtlest'),
};

export const HOVER_COLORS: {
	BLUE: 'var(--ds-background-accent-blue-subtlest-hovered)';
	GREEN: 'var(--ds-background-accent-green-subtlest-hovered)';
	YELLOW: 'var(--ds-background-accent-yellow-subtlest-hovered)';
	RED: 'var(--ds-background-accent-red-subtlest-hovered)';
	PURPLE: 'var(--ds-background-accent-purple-subtlest-hovered)';
} = {
	BLUE: token('color.background.accent.blue.subtlest.hovered'),
	GREEN: token('color.background.accent.green.subtlest.hovered'),
	YELLOW: token('color.background.accent.yellow.subtlest.hovered'),
	RED: token('color.background.accent.red.subtlest.hovered'),
	PURPLE: token('color.background.accent.purple.subtlest.hovered'),
};

export const COLOR_NAMES = {
	BLUE: 'blue',
	GREEN: 'green',
	YELLOW: 'yellow',
	RED: 'red',
	PURPLE: 'purple',
};
